import React from 'react';
import { Navbar, Container, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/actions/userActions';

/**
 * 头部导航组件
 * 显示系统标题、用户信息和退出按钮
 * @returns {JSX.Element} 返回头部导航组件
 */
function Header() {
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);

    /**
     * 处理退出登录
     */
    const handleLogout = () => {
        dispatch(logout());
    };

    return (
        <Navbar bg="white" expand="lg" className="border-bottom shadow-sm">
            <Container fluid className="px-4">
                {/* 系统Logo和标题 */}
                <Navbar.Brand className="fw-bold text-primary">
                    乐自智能管理后台
                </Navbar.Brand>

                {/* 用户信息和退出按钮 */}
                <div className="d-flex align-items-center">
                    <span className="me-3">欢迎，{currentUser?.name}</span>
                    <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={handleLogout}
                    >
                        退出登录
                    </Button>
                </div>
            </Container>
        </Navbar>
    );
}

export default Header;
